import gql from 'graphql-tag';

export const GET_SERVICE_RUN_WITH_PICKLISTS = gql`
	query($id: String) {
		getServiceRun(id: $id) {
			id
			planned
			route {
				id
				name
			}
			driver {
				id
				firstname
				lastname
				username
			}
			serviceDockets {
				id
				date
				order
				machineServiceType
				machineRestockType
				isRestocked
				tub
				picker {
					id
					firstname
					lastname
					username
				}
				packTags {
					id
					name
					abbreviation
				}
				machine {
					id
					assetId
					place {
						id
						name
					}
					type
					averageDaysSinceLastService
					planogram {
						id
						planogramItemGroups {
							id
							name
							order
						}
					}
					isOffline
					usesIngredients
					location {
						id
						name
						addressObj {
							id
							region
							street
							city
							postcode
						}
					}
					overrideUsePredictivePickLists
					overridePredictiveGlobalSettings
				}
				pickList {
					id
					calculatedAt
					pickers {
						id
						firstname
						lastname
						username
						destroyed
					}
					pickListItems {
						id
						isPicked
						extraQuantityIsPicked
						pickOrder
						documentHistoryCount
						planogramItem {
							id
							row
							column
							created
							selection
							quantity
							parlevel
							expiryDates
							price
							reportedPrice
							enabled
							isIngredient
							planogramItemGroupId
						}
						selection
						quantity
						extraQuantity
						tubWeightExcludedQuantity
						unadjustedQuantity
						planogramItemQuantity
						planogramItemParlevel
						planogramItemExpiryDatesAtPick
						originalPickQuantity
						originalPlanogramItemQuantity
						originalPickExtraQuantity
						lastCalculatedExtraQuantity
						swapQuantity
						product {
							id
							name
							imageUrl
							HCGCategory
							HFDCategory
							measurementUnit
							weight
							excludeFromTubWeightCalculation
						}
						removedProduct {
							id
							name
							imageUrl
						}
					}
				}
			}
		}
	}
`;
